module.exports = __webpack_public_path__ + "e14127e6edab891ca5bf63178b1a21e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_50.jpg
// module id = 1681
// module chunks = 5